
<div class="banner_header">
    <div class="col-md-12">
        <h2>  Exam Fees Payment </h2>
    </div>
</div>



<div class="container download_section pad_btm_size">


    <div class="row">
        <div class="col-md-12">

            <div *ngIf="form1">
                <!-- main app container -->
                <div class="card m-3">
                    <h3 class="card-header">Details of Bulk Payment Done </h3>

                    <div class="card-body" *ngIf="bool_bdnuForm">
                        <form [formGroup]="bdnuForm" (ngSubmit)="onSubmit()">
          
                            <div class="form-row">
                                <div class="form-group col-4">
                                    <label>State <span class="clr_red"> * </span></label>

                                    <select formControlName="state" class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f.state.errors }"
                                        (change)="onChangeState($event)">
                                        <option [selected]="true" value="" [disabled]="true">Select State
                                        </option>
                                        <option *ngFor="let country of state" [value]="country.State">
                                            {{ country.State }}
                                        </option>
                                    </select>
                                    <div *ngIf="submitted && f.state.errors" class="invalid-feedback">
                                        <div *ngIf="f.state.errors.required">Select Your State</div>
                                    </div>
                                </div>

                                <div class="form-group col-4">
                                    <label>District <span class="clr_red"> * </span></label>

                                    <select formControlName="district" class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f.district.errors }"
                                        (change)="onChangeDistrict($event)">
                                        <option [selected]="true" value="" [disabled]="true">Select District
                                        </option>
                                        <option *ngFor="let country of district" [value]="country.district">
                                            {{ country.district}}
                                        </option>
                                    </select>
                                    <div *ngIf="submitted && f.district.errors" class="invalid-feedback">
                                        <div *ngIf="f.district.errors.required">Select Your District</div>
                                    </div>
                                </div>

                                <div class="form-group col-4">
                                    <label>ITI Code (Enter ITI Code if not found in list)</label>

                                    <input *ngIf="bool_iti_text" type="text" formControlName="iticode" class="form-control"
                                         maxlength="50"
                                        placeholder="Enter Your ITI code"  />
                                    <select *ngIf="bool_iti_select" (change)="entry_iti($event)"   [ngClass]="{ 'is-invalid': submitted && f.iticode.errors }" formControlName="iticode" class="form-control"
                                       >
                                       <option value="Enter ITI Code" >Enter ITI Code
                                      </option>
                                        <option [selected]="true" value="" [disabled]="true">Select ITI Code
                                        </option>
                                        <option *ngFor="let city of iticode" [value]="city.iticode">
                                            {{ city.iticode }}
                                        </option>
                                    </select>

                                    <div *ngIf="submitted && f.iticode.errors" class="invalid-feedback">
                                        <div *ngIf="f.iticode.errors.required">Select Your ITI Code </div>
                                    </div>
     
                                </div>

                                <div class="form-group col-4">
                                    <label>Name <span class="clr_red"> * </span></label>
                                    <input type="text" formControlName="name" class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f.name.errors }" maxlength="50"
                                        placeholder="Enter Your Name" (keypress)="omit_text($event)" />
                                    <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                                        <div *ngIf="f.name.errors.required">Enter Your Name</div>
                                    </div>
                                </div>

                                <div class="form-group col-4">
                                    <label>Email Id <span class="clr_red"> * </span></label>
                                    <input type="text" formControlName="email" class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f.email.errors }" maxlength="50"
                                        placeholder="Enter Your Email Address" (keypress)="omit_email($event)" />
                                    <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                        <div *ngIf="f.email.errors.required">Enter Your Email Id</div>
                                        <div *ngIf="f.email.errors.pattern">
                                            Enter Your Email Id must be a Valid Address
                                        </div>

                                    </div>
                                </div>

                                <div class="form-group col-4">
                                    <label>Mobile Number <span class="clr_red"> * </span></label>
                                    <input type="text" formControlName="mobileno" class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f.mobileno.errors }" maxlength="10"
                                        placeholder="Enter Your Mobile Number" (keypress)="omit_number($event)" />
                                    <div *ngIf="submitted && f.mobileno.errors" class="invalid-feedback">
                                        <div *ngIf="f.mobileno.errors.required">
                                            Enter Your Mobile Number
                                        </div>
                                        <div *ngIf="f.mobileno.errors.pattern">
                                            Enter Your Valid Mobile Number
                                        </div>
                                    </div>

                     
                                </div>

                                <div class="form-group col-4">
                                    <label>CC Refernce Number / Order Id <span class="clr_red"> * </span></label>
                                    <input type="text" formControlName="ccrefno" class="form-control" 
                                     (change)="cc_check($event)" maxlength="13" [ngClass]="{ 'is-invalid': submitted && f.ccrefno.errors }" 
                                        placeholder="Enter CC Refernce Number / Order Id "
                                        (keypress)="omit_number($event)" />
                                    <div *ngIf="submitted && f.ccrefno.errors" class="invalid-feedback">
                                        <div *ngIf="f.ccrefno.errors.required">
                                            Enter Your CC Refernce number / Order Id
                                        </div>
                                    </div>
                                    <!-- <div *ngIf="submitted && f.ccrefno.errors" class="invalid-feedback">
                                        <div *ngIf="f.ccrefno.errors.pattern">
                                            Enter Your CC Refernce number Only Number
                                        </div>
                                    </div> -->


                                </div>


                                
                                <div class="form-group col-4">
                                    <label>Payment Date <span class="clr_red"> * </span></label>
                                

                                    <input class="form-control" formControlName="date"
                                        type="text"  [(ngModel)]="paydate"
                                        [ngClass]="{ 'is-invalid': submitted && f.date.errors }"
                                        placeholder="Enter Payment Date" [attr.disabled]='true' />

                                    <div *ngIf="submitted && f.date.errors" class="invalid-feedback">
                                        <div *ngIf="f.date.errors.required">
                                            Enter your Payment Date
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group col-4">
                                    <label>Amount <span class="clr_red"> * </span></label>
                                

                                    <input class="form-control" formControlName="payamount"
                                        type="text"  [(ngModel)]="totpayamount"
                                        [ngClass]="{ 'is-invalid': submitted && f.payamount.errors }"
                                        placeholder="Enter Amount"  [attr.disabled]='true'/>

                                    <div *ngIf="submitted && f.payamount.errors" class="invalid-feedback">
                                        <div *ngIf="f.payamount.errors.required">
                                            Enter your Amount
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group col-4">
                                    <label>Total Student <span class="clr_red"> * </span></label>
                                

                                    <input class="form-control" formControlName="studCount"
                                        type="text" [(ngModel)]="studCount"
                                        [ngClass]="{ 'is-invalid': submitted && f.studCount.errors }"
                                        placeholder="Enter Payment Date"  [attr.disabled]='true' />

                                    <div *ngIf="submitted && f.studCount.errors" class="invalid-feedback">
                                        <div *ngIf="f.studCount.errors.required">
                                            Total Student
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group col-4">
                                    <label>CC ref No <span class="clr_red"> * </span></label>
                                

                                    <input class="form-control" formControlName="crtccrefno"
                                        type="text"  [(ngModel)]="crtccrefno"
                                        [ngClass]="{ 'is-invalid': submitted && f.crtccrefno.errors }"
                                        placeholder="Enter CC ref no" [attr.disabled]='true' />

                                    <div *ngIf="submitted && f.crtccrefno.errors" class="invalid-feedback">
                                        <div *ngIf="f.crtccrefno.errors.required">
                                            Enter your CC ref no
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group col-4">
                                    <label>Order ID <span class="clr_red"> * </span></label>
                                

                                    <input class="form-control" formControlName="crtorderid"
                                        type="text"  [(ngModel)]="crtorderid"
                                        [ngClass]="{ 'is-invalid': submitted && f.crtorderid.errors }"
                                        placeholder="Enter Order ID" [attr.disabled]='true' />

                                    <div *ngIf="submitted && f.crtorderid.errors" class="invalid-feedback">
                                        <div *ngIf="f.crtorderid.errors.required">
                                            Enter your Order ID
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group col-12" *ngIf="bool_add">
    
                                    <div class="row">
                                        <div class="form-group col-6">
                                            <label>Number of Students for which exam was not conducted <span class="clr_red"> * </span></label>
                                            <input type="text" formControlName="numberofstud" class="form-control"
                                                [ngModel]="numberStud" [ngClass]="{
                          'is-invalid': submitted && f.numberofstud.errors
                        }" maxlength="2" (keyup)="onKey($event)" (change)="test($event)" maxlength="3"
                                                placeholder="Enter Number of Students"
                                                (keypress)="omit_number($event)" />
                                            <div *ngIf="submitted && f.numberofstud.errors" class="invalid-feedback">
                                                <div *ngIf="f.numberofstud.errors.required">
                                                    Enter Number of Students
                                                </div>
                                            </div>
                                        </div>
                                    

                                        <div class="form-group col-12">
                                            <!-- <button class="btn btn-success" type="button"
                                                (click)="addQualification()">Add </button> -->
                                            <div class="table table-bordered" formArrayName="qualification"
                                                style="text-align: center;">

                                                <div *ngFor="let quantity of qualification.controls; let i=index" [formGroupName]="i">

                                   
                                                    <input type="text" formControlName="bukregno" class="form-control"
                                                         (keypress)="omit_number($event)"
                                                        placeholder="Enter Your Register Number" required>

                                                    <!-- <p *ngIf="quantity.get('bukregno').invalid" style="font-size: 80%;
                                                    color: #dc3545;">Enter Your Register Number
                                                    </p> -->
                                                    

                                                    <!-- <p *ngIf="quantity.controls.bukregno.errors?.pattern" style="font-size: 80%;
                                                    color: #dc3545;">Enter Your Valid Register Number
                                                    </p> -->


                                                </div>
                                            </div>


                                         

                                        </div>

                                    </div>



                                </div>

                            

                            <hr>
                            

                                <div class="form-group col-12">
                                    <label>Any Other Additional Information</label>
                                    <textarea formControlName="descreption" class="form-control" [ngClass]="{
                      'is-invalid': submitted && f.descreption.errors
                    }" rows="3" (keypress)="omit_spl($event)" maxlength="500" style="resize: none;">

                    </textarea>
          

                                    <div *ngIf="submitted && f.descreption.errors" class="invalid-feedback">
                                        <div *ngIf="f.descreption.errors.maxLength">
                                            Enter Your Description
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group form-check">
                                    <input type="checkbox" formControlName="acceptTerms" id="acceptTerms"
                                        class="form-check-input" [ngClass]="{
                        'is-invalid': submitted && f.acceptTerms.errors
                      }" />
                                    <label for="acceptTerms" class="form-check-label">I agree that all the above
                                        information are correct</label>
                                    <div *ngIf="submitted && f.acceptTerms.errors" class="invalid-feedback">
                                    </div>
                                </div>                                


                            </div>

                            <div class="form-row">

                             

                                <div class="form-group col-12">
                                    <div class="text-center">
                                        <button class="btn btn-primary mr-1">Submit</button>
                                        <button class="btn btn-secondary" type="reset" (click)="onReset()">
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>



                </div>
            </div>


            <div class="example-container mat-elevation-z8" *ngIf="bool_table">
                <mat-table matTableExporter [dataSource]="dataSource_view" #t1Sort="matSort" matSort>
    
                    <!--- Note that these columns can be defined in any order.
                        The actual rendered columns are set as a property on the row definition" -->
    
                    <!-- Position Column -->
                    <ng-container matColumnDef="OrderID">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Order ID </mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{element.OrderID}} </mat-cell>
                    </ng-container>
    
    
                    <!-- Name Column -->
                    <ng-container matColumnDef="Amount">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Amount </mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{element.Amount}} </mat-cell>
                    </ng-container>
    
                    <ng-container matColumnDef="Date">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Date </mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{element.Date}} </mat-cell>
                    </ng-container>
    
                    <ng-container matColumnDef="CCAvenueRefNumber">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> CC Avenue Ref Number  </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.CCAvenueRefNumber}} </mat-cell>
                    </ng-container>
    
                    <ng-container matColumnDef="PaymentType">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Payment Type </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.PaymentType}} </mat-cell>
                    </ng-container>
    
                    <ng-container matColumnDef="CardName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Card Name  </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.CardName}} </mat-cell>
                    </ng-container>
    
    
                    <mat-header-row *matHeaderRowDef="displayedColumns_view"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns_view;"></mat-row>
    
                </mat-table>
    
                <mat-paginator #t1Paginator="matPaginator"  [length]="totallengthData" (page)="pageEvent = $event; pageChangedData($event)" [pageSizeOptions]="[ 5,10, 25, 50, 100, 500]"></mat-paginator>
    
    
                </div>

            <div class="eriformr_res_cls" *ngIf="bool_pri_result">
                <p>Your Fees Details has been Sucessfully Registered. </p>
                <p>Your Reference ID is <b> {{pri_genrateid}} </b> </p>
                <p>An Confirmation Email has been sent to your Registered Email Id </p>
                <!-- <p>The Status of your Complaint can be Tracked at <button (click)="track_fn()"
                        class="track_btn_cls">Track
                        Your complaint </button> </p>
                <p>To Raise Exam Related Issue Click Here <button class="track_btn_cls" routerLink="/crs"
                        routerLinkActive="active"> Exam
                        Related
                        Issue </button> </p> -->
            </div>


        </div>
    </div>




</div>
